<script setup>
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3"
import useSelectAuctionsModal from "@/Composables/useSelectAuctions";
import EditableNodeWrapper from "@/Components/Inputs/BlockEditor/Extension/Components/EditableNodeWrapper.vue"
import { onMounted, ref, watch } from "vue"
import { RectangleStackIcon, PlusIcon } from '@heroicons/vue/24/outline'
import Grid from "@/Components/Inputs/BlockEditor/Extension/Components/Grid.vue"
import EditGrid from "@/Components/Inputs/BlockEditor/Extension/Modals/EditGrid.vue"
import useNodeProps from "@/Composables/useNodeProps.js"
import AuctionCardPreview from "@/Components/Inputs/BlockEditor/Extension/Components/Auctions/AuctionCardPreview.vue"
import { PrimaryButton } from "@codinglabsau/ui";

const props = defineProps({
  ...nodeViewProps,
})

let {
  cols,
  spacing,
} = useNodeProps(props)

let selectedAuctions = ref([])

onMounted(() => {
  if (props.extension.options.data.hasOwnProperty(props.node.attrs.id)) {
    selectedAuctions.value = [...props.extension.options.data[props.node.attrs.id].auctions]
  }
})

const addAuction = (auction) => {
  if (selectedAuctions.value.find(obj => obj.id === auction.id)) {
    alert(__('Auction already added'))
    return
  }
  selectedAuctions.value.push(auction)
}

const { open } = useSelectAuctionsModal(addAuction)

const removeAuction = (id) => {
  selectedAuctions.value = selectedAuctions.value.filter(auction => auction.id !== id);
}

watch(() => selectedAuctions.value, () => {
  props.updateAttributes({
    auctions: selectedAuctions.value.map(auction => auction.id)
  })
}, {deep:true})
</script>

<template>
  <node-view-wrapper>
    <EditableNodeWrapper v-bind="props">
      <template #tools>
        <EditGrid
          v-model:cols="cols"
          v-model:spacing="spacing"
        />
      </template>
      <template #content>
        <div class="w-full">
          <div class="flex w-full">
            <node-view-content class="first:prose-headings:mt-2"/>
          </div>
          <div v-if="selectedAuctions.length > 0">
            <Grid :cols="cols" :spacing="spacing">
              <AuctionCardPreview
                v-for="auction in selectedAuctions"
                @remove="removeAuction(auction.id)"
                :auction="auction"
              />
              <div
                @click.prevent="open"
                class="relative cursor-pointer rounded-xl bg-white border-2 border-gray-300 border-dashed text-gray-300 hover:bg-gray-300 hover:bg-opacity-50 hover:text-white"
              >
                <div class="self-stretch flex-grow">
                  <div class="aspect-1">
                    <div class="absolute inset-0 flex items-center justify-center">
                      <div class="text-center">
                        {{ __('Add another Auction') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </div>
          <div v-else class="my-4 text-center space-y-1">
            <RectangleStackIcon class="mx-auto w-12 h-12 text-gray-300"/>
            <h3 class="text-sm font-semibold text-gray-600">
              {{ __('No Auctions selected') }}
            </h3>
            <p class="text-gray-400 text-sm">
              {{ __('Select or search a Auction') }}
            </p>
            <PrimaryButton
              @click.prevent="open"
              as="button"
              type="button"
            >
              <PlusIcon class="-ml-0.5 mr-1.5 h-5 w-5" aria-hidden="true"/>
              {{ __('Search for Auctions') }}
            </PrimaryButton>
          </div>
        </div>
      </template>
    </EditableNodeWrapper>
  </node-view-wrapper>
</template>
